import { render, staticRenderFns } from "./OrderFlagMarker.vue?vue&type=template&id=765ec3e7&scoped=true"
import script from "./OrderFlagMarker.vue?vue&type=script&lang=js"
export * from "./OrderFlagMarker.vue?vue&type=script&lang=js"
import style0 from "./OrderFlagMarker.vue?vue&type=style&index=0&id=765ec3e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765ec3e7",
  null
  
)

export default component.exports